import { createModel } from '@/store/tools';

const model = {
    namespace: 'suggestions',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getlistIdeaBack': T('getlistIdeaBack'), // 意见反馈列表
            'getideaBackInfo': T('getideaBackInfo'), // 意见反馈详情
            'getfindIdeaBackTypeItem': T('getfindIdeaBackTypeItem'), // 反馈类型下拉
            'getAccountIdeaBackTypeEnum': T('getAccountIdeaBackTypeEnum'), // 用户类型下拉
        },
        actions: {
             'getlistIdeaBack': A('getlistIdeaBack'), // 意见反馈列表
             'getideaBackInfo': A('getideaBackInfo'), // 意见反馈详情
             'getfindIdeaBackTypeItem': A('getfindIdeaBackTypeItem'), // 反馈类型下拉
             'getAccountIdeaBackTypeEnum': A('getAccountIdeaBackTypeEnum'), // 用户类型下拉
        },
        sagas: {
            'getlistIdeaBack': S('getlistIdeaBack', '/?cmd=com.xqxc.api.pig.mis.biz.platform.IdeaBackService.listIdeaBack'),
            'getideaBackInfo': S('getideaBackInfo', '/?cmd=com.xqxc.api.pig.mis.biz.platform.IdeaBackService.ideaBackInfo'),
            'getfindIdeaBackTypeItem': S('getfindIdeaBackTypeItem', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getAccountIdeaBackTypeEnum': S('getAccountIdeaBackTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
        },
        reducers: {
            'listIdeaBack': R('getlistIdeaBack', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'ideaBackInfo': R('getideaBackInfo', {}),
            'findIdeaBackTypeItem': R('getfindIdeaBackTypeItem', []),
            'AccountIdeaBackTypeEnum': R('getAccountIdeaBackTypeEnum', []),
        }
    })
};
export default createModel(model);